'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('freightTime', {
    url: '/freightTime',
    template: '<freight-time></freight-time>'
  });
}


// WEBPACK FOOTER //
// ./client/app/freightTime/freightTime.routes.js